import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/icons/jpg-png/cookie-small.png")